import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import stockService from "../services/stockService";
import supplierService from "../services/supplierService";
const initialState = {
    suppliers: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
};

const supplierSlice = createModule({
    name: 'suppliers',
    initialState,
    reducers: {
        addSupplier: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        updateSupplier: (state) => {
            state.loading = true;
        },
        deleteSupplier: (state, action) => {
            state.loading = true;
        },
       
        fetchedData: (state, payload) => {
            state.loading = false;
            state.suppliers = payload.body.content;
            state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.body.pageNumber;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state, action) => {
            state.isFetching = false;
            state.error = action.payload || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(supplierService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if(payload.onSuccess) {
                    yield call(payload.onSuccess, data.body);
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addSupplier]({ payload }) {
            try {
                const { data } = yield call(supplierService.save, payload.data);
                yield put(A.finishFetching());
                yield put(A.search({ query: '' }));
                if(payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
                
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.updateSupplier]({ payload }) {
            try {
                yield call(supplierService.update, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.deleteSupplier]({ payload }) {
            try {
                const { data } = yield call(supplierService.delete, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        
    }),
});

export default supplierSlice;
export const supplierActions = supplierSlice.actions;
export const supplierSelectors = {
    getSuppliers: state => state.suppliers || [],
    getSuppliersLoading: state => state.loading || false,
    getSuppliersTotalPages: state => state.totalPages || 0,
    getSuppliersTotalElements: state => state.totalElements || 0
  };